import { createPiniaInstance } from "@/store/pinia/createPiniaInstance";

const pinia = createPiniaInstance();

export default pinia;